import { HelpContent } from 'src/app/UI-Lib/Help-Tooltip';

export const DELIVERY_DETAILS_HELP: HelpContent[] = [
    {
        helpContentId: 'delivery-details.payment-batch-modal',
        tooltipText: 'Please select workflow and assign required tasks.',
        hasIcon: true
    }
];
